module.exports = __webpack_public_path__ + "img/dpin_quiz_night_creation.5bb85b07.png";